const styles = theme => ({
  headerSelected: {
    backgroundColor: '#E3F3FF',
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '8px',
    gap: '6px',
    justifyContent: 'center',
    '&:hover $moreFillIcon': {
      color: '#212B36', // Color when the box is hovered
      width: '14px',
      margin: '0 4px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    borderRadius: '8px',
    gap: '4px',
    transition: 'background-color 0.3s, color 0.3s', // Add transition for smooth animation
    '&:hover': {
      backgroundColor: '#E3F3FF',
      cursor: 'pointer',
    },
    '&:hover $selectionDragIcon': {
      color: '#212B36', // Color when the box is hovered
    },
    '&:hover $moreFillIcon': {
      color: '#212B36', // Color when the box is hovered
      width: '14px',
      margin: '0 4px',
    },
  },
  moreFillIcon: {
    width: '0px',
  },
})
export default styles
